module.exports = __webpack_public_path__ + "img/33_18.9d126c26.png";